import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  breadcrumbLabelsVersion,
  getBreadcrumbLabel,
  subscribeBreadcrumbLabels,
} from './breadcrumbLabels.js';
import { isNavigablePath } from './navigableRoutes.js';

export function Breadcrumb(): React.ReactElement {
  const loc = useLocation();
  React.useSyncExternalStore(subscribeBreadcrumbLabels, breadcrumbLabelsVersion, breadcrumbLabelsVersion);
  const parts = loc.pathname.split('/').filter(Boolean);
  const crumbs: Array<{ label: string; to: string; navigable: boolean }> = [];
  let acc = '';
  for (const p of parts) {
    acc += `/${p}`;
    crumbs.push({ label: getBreadcrumbLabel(p) ?? humanize(p), to: acc, navigable: isNavigablePath(acc) });
  }
  return (
    <nav aria-label="breadcrumb" data-testid="breadcrumb" className="tl-breadcrumb">
      <Link to="/dashboard">Home</Link>
      {crumbs.map((c, i) => (
        <span key={c.to}>
          <span aria-hidden="true" className="tl-breadcrumb__sep"> / </span>
          {i === crumbs.length - 1 ? (
            <span aria-current="page" className="tl-breadcrumb__current">
              {c.label}
            </span>
          ) : c.navigable ? (
            <Link to={c.to}>{c.label}</Link>
          ) : (
            <span className="tl-breadcrumb__step">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function humanize(s: string): string {
  // Record ids are in the URL but mean nothing to the reader, and humanising
  // one turns it into "F994bce3 B2c2 499b ...".
  if (UUID.test(s) || /^\d+$/.test(s)) return 'Details';
  return s
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
